import IconStarFilled from "@src/assets/icons/tabler/star-filled.svg?react";
import IconStar from "@src/assets/icons/tabler/star.svg?react";
import { NativeLikeTooltip as Tooltip } from "@src/components/ui/native-like-tooltip";
import clsx from "clsx";

export type NavTreeTab = "pinned" | "workspace" | "shared";

interface NavSectionTabsProps {
	activeTab: NavTreeTab;
	onTabChange: (tab: NavTreeTab) => void;
}

export function NavSectionTabs({
	activeTab,
	onTabChange,
}: NavSectionTabsProps) {
	const isWorkspace = activeTab === "workspace";
	const isShared = activeTab === "shared";
	const isPinned = activeTab === "pinned";

	return (
		<div
			className={clsx(
				"mx-3 flex items-center justify-between",
				"border-t border-border-subtle pt-1",
			)}
		>
			<div className="flex items-center gap-0.5">
				<button
					type="button"
					aria-pressed={isWorkspace}
					onClick={() => onTabChange("workspace")}
					className={clsx(
						"h-6.5 rounded-md px-2 text-xs transition-colors",
						"cursor-pointer select-none",
						isWorkspace
							? "bg-surface-subtle font-semibold text-text-primary"
							: "font-medium text-text-secondary hover:bg-surface-hover-subtle hover:text-text-primary",
					)}
				>
					Workspace
				</button>
				<button
					type="button"
					aria-pressed={isShared}
					onClick={() => onTabChange("shared")}
					className={clsx(
						"h-6.5 rounded-md px-2 text-xs transition-colors",
						"cursor-pointer select-none",
						isShared
							? "bg-surface-subtle font-semibold text-text-primary"
							: "font-medium text-text-secondary hover:bg-surface-hover-subtle hover:text-text-primary",
					)}
				>
					Shared
				</button>
			</div>

			<Tooltip label="Favourites" openDelay={300} withArrow>
				<button
					type="button"
					aria-label="Favourites"
					aria-pressed={isPinned}
					onClick={() => onTabChange("pinned")}
					className={clsx(
						"flex h-6.5 items-center gap-1 rounded-md px-2 text-xs",
						"transition-colors cursor-pointer select-none",
						isPinned
							? "bg-amber-500/15 font-semibold text-amber-700"
							: "font-medium text-text-secondary hover:bg-surface-hover-subtle hover:text-text-primary",
					)}
				>
					{isPinned ? (
						<IconStarFilled width={12} height={12} className="text-amber-500" />
					) : (
						<IconStar width={12} height={12} />
					)}
					<span>Favourites</span>
				</button>
			</Tooltip>
		</div>
	);
}
